/* Plan guides and carrier pages: finder tabs (sections/plan-page.liquid). Panels are server-rendered; this only switches them. */
(function () {
  document.querySelectorAll('[data-pg-finder]').forEach(function (f) {
    var tabs = f.querySelectorAll('[data-pg-tab]');
    function pick(t) {
      tabs.forEach(function (b) {
        var on = b === t;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        document.getElementById(b.getAttribute('aria-controls')).hidden = !on;
      });
    }
    tabs.forEach(function (b, i) {
      b.addEventListener('click', function () { pick(b); });
      b.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        var n = tabs[(i + d + tabs.length) % tabs.length]; pick(n); n.focus();
      });
    });
  });
})();
